import React, { useEffect } from "react";
import {
  Text,
  TextField,
  Group,
  TextInput,
  PasswordInput,
  Checkbox,
  Divider,
  Card,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useForceUpdate } from "@mantine/hooks";
import moment from "moment";

const loginCheckboxStyles = {
  label: {
    fontSize: "var(--mantine-font-size-sm)",
    fontWeight: 400,
    lineHeight: "var(--mantine-line-height-sm)",
  },
};

const LoginInfoRow = ({ item, form, name }) => {
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    const isNewRow =
      !item.content.label &&
      !item.content.url &&
      !item.content.username &&
      !item.content.creationDate;
    if (isNewRow) {
      item.content.creationDate = new Date();
      forceUpdate();
    }
  }, []);

  const toDateValue = (value) =>
    value ? moment(value).toDate() : null;

  return (
    <Card>
      <Group mb="xl" spacing="lg">
        <Checkbox
          size="sm"
          styles={loginCheckboxStyles}
          label="Show to Consultant?"
          checked={!!item.content["isPublic"]}
          onChange={(e) => {
            item.content["isPublic"] = e.target.checked;
            forceUpdate();
          }}
        />
        <Checkbox
          size="sm"
          styles={loginCheckboxStyles}
          label="Inactive"
          checked={!!item.content["inactive"]}
          onChange={(e) => {
            item.content["inactive"] = e.target.checked;
            forceUpdate();
          }}
        />
        {item.content && item.content.url && (
          <a
            href={item.content.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: "0.8rem",
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              textDecoration: "none",
            }}
          >
            <span role="img" aria-label="link" style={{ fontSize: "1.1em" }}>
              🔗
            </span>
            {item.content.url}
          </a>
        )}
      </Group>
      <Group grow mt={"sm"}>
        <TextInput
          placeholder="e.g. AIA Login Page"
          label="Label"
          value={item.content["label"]}
          onChange={(e) => {
            item.content["label"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          placeholder="http://www.aia.com.hk"
          label="URL Address"
          value={item.content["url"]}
          miw={400}
          onChange={(e) => {
            item.content["url"] = e.target.value;
            forceUpdate();
          }}
        />
      </Group>
      <Group grow mt={"sm"}>
        <TextInput
          placeholder="Username"
          label="Login Name / Email"
          value={item.content["username"]}
          onChange={(e) => {
            item.content["username"] = e.target.value;
            forceUpdate();
          }}
        />
        <PasswordInput
          placeholder="Password"
          label="Password"
          value={item.content["password"]}
          autoComplete="new-password"
          onChange={(e) => {
            item.content["password"] = e.target.value;
            forceUpdate();
          }}
        />
      </Group>
      <Group grow mt={"sm"}>
        <TextInput
          placeholder="OTP Phone"
          label="OTP Phone"
          value={item.content["otpPhone"]}
          onChange={(e) => {
            item.content["otpPhone"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          placeholder="OTP Email"
          label="OTP Email"
          value={item.content["otpEmail"]}
          onChange={(e) => {
            item.content["otpEmail"] = e.target.value;
            forceUpdate();
          }}
        />
      </Group>
      <Group grow mt="sm">
        <DatePicker
          label="Creation date"
          allowFreeInput
          value={toDateValue(item.content["creationDate"])}
          onChange={(d) => {
            item.content["creationDate"] = d;
            forceUpdate();
          }}
        />
        <DatePicker
          label="Termination date"
          allowFreeInput
          clearable
          value={toDateValue(item.content["terminationDate"])}
          onChange={(d) => {
            item.content["terminationDate"] = d;
            forceUpdate();
          }}
        />
      </Group>
      <Divider mt="xl" />
    </Card>
  );
};

export default LoginInfoRow;
